import { render } from "./FormularioExecucaoTestador.vue?vue&type=template&id=34bce0dc&scoped=true"
import script from "./FormularioExecucaoTestador.vue?vue&type=script&lang=js"
export * from "./FormularioExecucaoTestador.vue?vue&type=script&lang=js"

import "./FormularioExecucaoTestador.vue?vue&type=style&index=0&id=34bce0dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34bce0dc"]])

export default __exports__